import React from 'react';

import { Marker, Popup } from '@monsonjeremy/react-leaflet';
import { Grid, Typography } from '@mui/material';

export const UfficioMarker = ({ ufficiData, ufficioData, markerRefs, icon, onMarkerClick, ...props }) => {

    return (<>
        <Marker
            ref={e => {
                if (e)
                    markerRefs.current[ufficioData.id] = e
            }}
            icon={icon}
            position={[ufficioData.latitudine, ufficioData.longitudine]}
            eventHandlers={{
                popupopen: (e) => {
                    e.popup._closeButton.removeAttribute("href");
                    e.popup._closeButton.style.cursor = "pointer";
                    setTimeout(
                        function () {
                            onMarkerClick([...ufficiData.filter(x => x.latitudine === ufficioData.latitudine && x.longitudine === ufficioData.longitudine).map(x => x.id)]);
                        }, 0);
                }
            }}
        >
            <Popup>
                <Grid item xs={12} container alignItems='center' marginBottom={2} >
                    <Grid item xs>
                        {
                            ufficiData.filter(x => x.latitudine === ufficioData.latitudine && x.longitudine === ufficioData.longitudine)?.map(x => {
                                return <Typography style={{ marginTop: 3 }} key={x.id}>
                                    {x.nome}
                                </Typography>
                            })
                        }
                    </Grid>
                </Grid>
            </Popup>
        </Marker>
    </>

    );
}